module.exports = __webpack_public_path__ + "img/team-9.b449080f.png";